export default __webpack_public_path__ + "static/media/ArrowGreen.0e85804a.svg";